import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { DebounceInput } from "react-debounce-input";
import { NumToFa} from "../../Functions/TextTransform";
import NumberToPersianWord from "number_to_persian_word";



export default function Step5CTrackFloorPleatedSheer({
 step3, step31, step3ATrack, depSet, accordionActiveKey, t, stepSelectedLabel, requiredStep, setCart, setCartLoading, setDeps, optionSelectChanged, selectChanged, pageLanguage, rodToFloor, setRodToFloor, step3A0,NextStep , ContextAwareToggle
}) {
  
  return (
   <Card
   className={
     step3 === "true" &&
     step31 === "Track" &&
     (step3ATrack === "Floor" || step3ATrack === "Slight Puddle")
       ? ""
       : "noDisplay"
   }
 >
   <Card.Header
     className={
       [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
       !accordionActiveKey.startsWith("3")
         ? "hidden"
         : ""
     }
   >
     <ContextAwareToggle
       eventKey="3C"
       stepNum={t("4C")}
       stepTitle={t("pleated_step3DRodFloor")}
       stepRef="3CRodFloor"
       type="2"
       required={requiredStep["3CRodFloor"]}
       stepSelected={
         stepSelectedLabel["3CRodFloor"] === undefined
           ? ""
           : stepSelectedLabel["3CRodFloor"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="3C">
     <Card.Body>
       <div className="card_body">
         <div className="box100">
           <p className="step_selection_title">{t("pleated_step3DTrackFloor_title")}</p>
           <img
             src={
               pageLanguage === "fa"
                 ? step3A0 === "Moulding"
                   ? require("../../Images/drapery/grommet/RodtoFloor_arc_fa.svg").default
                   : require("../../Images/drapery/grommet/RodtoFloor_fa.svg").default
                 : step3A0 === "Moulding"
                 ? require("../../Images/drapery/grommet/RodtoFloor_arc.svg").default
                 : require("../../Images/drapery/european/5c2.svg").default
             }
             className="img-fluid just_frame"
             alt=""
           />
         </div>
         <div className="box100 Three_selection_container">
           <div className="box100">
             <div className="measure_input_container">
               <h1 className="measure_input_label">{t("Height")}</h1>
               <div className="measure_input_field_container">
                 <DebounceInput
                   debounceTimeout={1500}
                   autoComplete="off"
                   onKeyDown={(e) => {
                     if (
                       !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                       e.keyCode !== 8 &&
                       e.keyCode !== 46 &&
                       e.keyCode !== 37 &&
                       e.keyCode !== 39 &&
                       e.keyCode !== 13
                     ) {
                       e.preventDefault();
                     }
                   }}
                   className={
                     "measure_input" +
                     (rodToFloor !== undefined && (rodToFloor < 1 || rodToFloor > 1000)
                       ? " measure_input_err"
                       : "")
                   }
                   type="text"
                   name="rodToFloor1"
                   value={NumToFa(`${rodToFloor || ""}`, pageLanguage)}
                   onChange={(e) => {
                     setTimeout(() => {
                       let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                       newValue = isNaN(newValue) ? "" : newValue;
                       if (
                         newValue &&
                         newValue !== "" &&
                         parseInt(newValue) >= 1 &&
                         parseInt(newValue) <= 1000
                       ) {
                         setCartLoading(true);
                         setCart("RodToFloor", parseInt(newValue));
                         setDeps("", "3CRodFloor");
                         setRodToFloor(parseInt(newValue));
                         optionSelectChanged(
                           "3CRodFloor",
                           parseInt(newValue),
                           "cm",
                           "س\u200Cم",
                           pageLanguage
                         );
                       } else {
                         setCartLoading(true);
                         setCart("", "", "RodToFloor");
                         setDeps("3CRodFloor", "");
                         if (newValue === "" || isNaN(parseInt(newValue))) {
                           setRodToFloor(undefined);
                           selectChanged(undefined, "3CRodFloor");
                         } else {
                           setRodToFloor(parseInt(newValue));
                           selectChanged(
                             "3CRodFloor",
                             undefined,
                             t("Invalid Measurements")
                           );
                         }
                       }
                     }, 300);
                   }}
                 />
                 <div className="measure_input_postfix">{t("cm_label")}</div>
               </div>
             </div>
           </div>
         </div>
         <NextStep currentStep="3CRodFloor" eventKey="3D">
           {t("NEXT STEP")}
         </NextStep>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
